import api from '../../api'

const getDefaultState = () => {
  return {
    all: []
  }
}

const state = getDefaultState()

const getters = {
  getAll: (state) => state.all
}

const actions = {
  fetchAll ({ rootGetters, commit }) {
    return new Promise((resolve) => {
      api.getNotice(rootGetters['user/getLang'])
        .then(messages => {
          commit('setNotice', messages)
          resolve()
        })
        .catch(() => {
          commit('resetState')
          resolve()
        })
    })
  },
  reset ({ commit }) {
    commit('resetState')
  }
}

const mutations = {
  setNotice (state, messages) {
    state.all = messages
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
